import { Starter } from '../../../../starters/types/StartersTypes';
import { Request } from '../../requests/Request';
import { IResult } from '../../types/IResponse';

export interface GetAllWorkbookStartersResult extends IResult{
  workbookTemplates: Starter[];
}

export class GetAllWorkbookStartersRequest
  extends Request<{}, GetAllWorkbookStartersResult>
{
  constructor() {
    super('getAllWorkbookTemplates', {});
  }
}
